export default __webpack_public_path__ + "static/media/lgb-hollywood-cover.ab01a214.jpg";